// extracted by mini-css-extract-plugin
export default {"form-items-row":"styles_form-items-row__fjCPI","form-item":"styles_form-item__22eps","form-item-right":"styles_form-item-right__KkIuR"};